<template>
  <v2-modal
    :show="show"
    title="Delete Teammate"
    size="sm"
    @close="$emit('close')"
  >
    <p class="v2-text-sm">
      Are you sure you want to delete {{ teammate && teammate.firstName ? teammate.firstName : 'this teammate' }}?
    </p>

    <template #footer>
      <v2-button
        variant="outline"
        @click="$emit('close')"
      >
        Cancel
      </v2-button>
      <v2-button
        variant="destructive"
        @click="$emit('confirm')"
      >
        Yes, Delete
      </v2-button>
    </template>
  </v2-modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'

export default {
  name: 'V2DeleteTeammateModal',
  components: {
    V2Modal,
    V2Button,
  },
  props: {
    show: { type: Boolean, default: false },
    teammate: { type: Object, default: () => ({}) },
  },
}
</script>
